import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=252d4072&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=252d4072&prod&scoped=true&lang=scss"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=252d4072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d4072",
  null
  
)

export default component.exports